import React from 'react';
import { motion } from 'framer-motion';
export function BonusesSection() {
  const bonuses = [{
    num: '1',
    title: 'Almohadones virales',
    desc: '+10.000 diseños de almohadones con las últimas tendencias.',
    image: 'https://cdn.magicpatterns.com/uploads/f1kqvXBhdkBcCE5WiYjtss/6f0c32fc-e721-440b-ae2e-fc4bede85569-Photoroom.png'
  }, {
    num: '2',
    title: 'Diseños de tazas',
    desc: '+10.000 diseños de tazas virales.',
    image: 'https://cdn.magicpatterns.com/uploads/qonNTmP1WGF4bdQDEEYNYc/b10cc40c-4874-4802-b38e-585a41c4bccb-Photoroom.png'
  }, {
    num: '3',
    title: 'Stickers virales',
    desc: 'Stickers imperdibles para complementar tus ventas.',
    image: 'https://cdn.magicpatterns.com/uploads/jsJNav2kwTafCaUjrgmbGr/aaf83362-4e5a-4d54-88e7-b14e06815194-Photoroom.png'
  }];
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-14 md:py-16 bg-gradient-to-b from-[#0a0e1a] to-[#111827] relative overflow-hidden" data-id="element-23">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#f5a623]/8 rounded-full blur-[100px] pointer-events-none" data-id="element-24" />

      <div className="max-w-[980px] mx-auto px-4 relative z-10" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-26">
          <h2 className="text-[24px] md:text-[32px] font-black text-[#ef4444] mb-3 uppercase" data-id="element-27">
            ¡PERO ESO NO ES TODO!
          </h2>
          <p className="text-xl md:text-2xl font-bold text-white" data-id="element-28">
            Accediendo hoy también recibís estos BONOS EXCLUSIVOS:
          </p>
        </motion.div>

        <div className="flex flex-col items-center space-y-6" data-id="element-29">
          {bonuses.map((bonus, idx) => <div key={idx} className="w-full flex flex-col items-center" data-id="element-30">
              <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="w-full max-w-2xl bg-gradient-to-br from-[#1a1f35] to-[#0a0e1a] p-5 md:p-6 rounded-2xl border border-[#f5a623]/30 cursor-pointer hover:border-[#f5a623] transition-colors duration-300" onClick={scrollToPricing} data-id="element-31">
                <div className="flex flex-col md:flex-row items-center gap-5" data-id="element-32">
                  <div className="w-full max-w-[200px] md:max-w-[180px] flex-shrink-0" data-id="element-33">
                    <img src={bonus.image} alt={bonus.title} className="w-full h-auto rounded-xl drop-shadow-lg" data-id="element-34" />
                  </div>
                  <div className="flex-1 text-center md:text-left" data-id="element-35">
                    <span className="text-[#f5a623] font-black tracking-widest uppercase text-xs mb-1.5 block" data-id="element-36">
                      BONO {bonus.num}
                    </span>
                    <h3 className="text-2xl font-bold text-white mb-2" data-id="element-37">
                      {bonus.title}
                    </h3>
                    <p className="text-[17px] text-gray-300 mb-4" data-id="element-38">
                      {bonus.desc}
                    </p>
                    <div className="inline-block bg-[#22c55e] text-white font-bold px-5 py-1.5 rounded-full text-sm" data-id="element-39">
                      GRATIS HOY CON TU COMPRA
                    </div>
                  </div>
                </div>
              </motion.div>

              {idx < bonuses.length - 1 && <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} className="text-4xl font-black text-[#f5a623] my-3" data-id="element-40">
                  +
                </motion.div>}
            </div>)}
        </div>
      </div>
    </section>;
}